import { render, staticRenderFns } from "./SelectFee.vue?vue&type=template&id=7024263c"
import script from "./SelectFee.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectFee.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports